// extracted by mini-css-extract-plugin
export default {"wrapper":"CategoryImage_wrapper__8qJ+H","fill":"CategoryImage_fill__mtBYj","imageFit":"CategoryImage_imageFit__QCSN3","typedImage":"CategoryImage_typedImage__u8rI1"};